import { render, staticRenderFns } from "./clnt_askprc.vue?vue&type=template&id=1274de67&scoped=true"
import script from "./clnt_askprc.vue?vue&type=script&lang=js"
export * from "./clnt_askprc.vue?vue&type=script&lang=js"
import style0 from "./clnt_askprc.vue?vue&type=style&index=0&id=1274de67&prod&scoped=true&lang=less"
import style1 from "./clnt_askprc.vue?vue&type=style&index=1&id=1274de67&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274de67",
  null
  
)

export default component.exports